import { queries } from "@corpuscomplete/core/zero";
import { ListsPage } from "@corpuscomplete/web/modules/common/list/pages/lists";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/lists/")({
  component: ListsPage,
  loader: async ({ context }) => {
    void context.zero?.run(queries.list.all());
  },
});
